import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { FiMenu, FiX } from 'react-icons/fi';
import { FaPhone, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { FaTelegram } from 'react-icons/fa6';
import { SiTiktok } from 'react-icons/si';
import EskistaLogo from '../../assets/imgs/logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className={`navbar-container ${scrolled ? 'scrolled' : ''}`}>
      {/* Topbar */}
      <div className="topbar">
        <div className="topbar-content container">
          <div className="contact-info">
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <span>+251 911 465 364</span>
            </div>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>DH Geda Tower, Bole Road, Addis Ababa</span>
            </div>
          </div>
          
          <div className="social-media">
            <a href="https://www.facebook.com/eskistarental" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://www.instagram.com/eskistarental" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://www.linkedin.com/company/eskistarental/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="https://www.tiktok.com/@eskistarental" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><SiTiktok /></a>
            <a href="https://t.me/eskistarental" target="_blank" rel="noopener noreferrer" aria-label="Telegram"><FaTelegram /></a>
          </div>
        </div>
      </div>

      {/* Sticky Menu Bar */}
      <nav className="menu-bar">
        <div className="menu-content menu-container">
          {/* Logo */}
          <div className="logo">
            <a href="/">
              <img src={EskistaLogo} alt="Eskista Rental Logo" className="logo-image" />
            </a>
          </div>

          {/* Desktop Menu Links */}
          <div className="nav-links">
            <a href="#home" className="nav-link">Home</a>
            <a href="#about-section" className="nav-link">About Us</a>
            <a href="#gear-section" className="nav-link">Gears</a>
            <a href="#video-studios-section" className="nav-link">Studio</a>
            <a href="#testimonial-section" className="nav-link">Testimonial</a>
            <button className="nav-cta-button">Book a Rental</button>
          </div>

          {/* Mobile Menu Button */}
          <button className="mobile-menu-button" onClick={toggleMenu} aria-label="Menu">
            {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
          <div className="mobile-menu-header">
            <img src={EskistaLogo} alt="Eskista Rental Logo" className="mobile-logo" />
            <button className="mobile-menu-close" onClick={toggleMenu} aria-label="Close menu">
              <FiX size={24} />
            </button>
          </div>
          <a href="#" className="mobile-nav-link">Home</a>
          <a href="#about-section" className="mobile-nav-link">About Us</a>
          <a href="#gear-section" className="mobile-nav-link">Gears</a>
          <a href="#video-studios-section" className="mobile-nav-link">Studio</a>
          <a href="#testimonial-section" className="mobile-nav-link">Testimonial</a>
          <button className="mobile-nav-cta-button">Book a Rental</button>
          
          <div className="mobile-social-media">
            <a href="https://www.facebook.com/eskistarental" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://www.instagram.com/eskistarental" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://www.linkedin.com/company/eskistarental/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="https://www.tiktok.com/@eskistarental" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><SiTiktok /></a>
            <a href="https://t.me/eskistarental" target="_blank" rel="noopener noreferrer" aria-label="Telegram"><FaTelegram /></a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;